module.exports = __webpack_public_path__ + "static/media/Super-scalper1.439cbf1e.PNG";